"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightshowEngine = void 0;
const lightshow_v1_1 = require("./lightshow_v1");
const lightshow_v2_1 = require("./lightshow_v2");
const logger_1 = require("../util/logger");
class LightshowEngine {
    constructor(remoteParticipantCapabilities) {
        this.remoteParticipantCapabilities = remoteParticipantCapabilities;
        // Start with V1 until we get word that the remote can send V2
        this.lightshow = new lightshow_v1_1.LightshowV1();
    }
    connect(dataTrack) {
        var _a, _b;
        this.lightshow.connect(dataTrack);
        // If the remote declares it is capable of Lightshow V2, switch to using that.
        (_a = this.remoteCapabilitiesListener) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.remoteCapabilitiesListener = (_b = this.remoteParticipantCapabilities) === null || _b === void 0 ? void 0 : _b.subscribe(capabilities => {
            const supportsLightshowV2 = Boolean(capabilities === null || capabilities === void 0 ? void 0 : capabilities.supportsLightshowV2);
            logger_1.logger.info('Received remote capabilities, supportsLightshowV2?', supportsLightshowV2.toString());
            if (supportsLightshowV2 && this.lightshow instanceof lightshow_v1_1.LightshowV1) {
                logger_1.logger.info('Switching to LightshowV2');
                this.lightshow.disconnect();
                this.lightshow = new lightshow_v2_1.LightshowV2();
                this.lightshow.connect(dataTrack);
            }
            else if (!supportsLightshowV2 && this.lightshow instanceof lightshow_v2_1.LightshowV2) {
                logger_1.logger.info('Switching to LightshowV1');
                this.lightshow.disconnect();
                this.lightshow = new lightshow_v1_1.LightshowV1();
                this.lightshow.connect(dataTrack);
            }
        });
    }
    disconnect() {
        var _a;
        (_a = this.remoteCapabilitiesListener) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.remoteCapabilitiesListener = undefined;
        this.lightshow.disconnect();
    }
    getLongEdgeOffset(longEdge) {
        return this.lightshow.getLongEdgeOffset(longEdge);
    }
    getLightshowAvoidingRect(videoElement) {
        return this.lightshow.getLightshowAvoidingRect(videoElement);
    }
    extractCameraFrame(videoElement) {
        return this.lightshow.extractCameraFrame(videoElement);
    }
}
exports.LightshowEngine = LightshowEngine;
//# sourceMappingURL=engine.js.map